// Global Instructions Rule Applied!
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store.ts'

/**
 * Per-report `cfg.reporting_config.freeze_leading_columns` — how many of the
 * leftmost VISIBLE columns the grid should pin (AntD fixed:'left'). 0
 * (default) = none. Positional, so it tracks the actual leftmost column for
 * aggregation-driven grids where that changes with the active grain.
 */
export function useFreezeLeadingColumns(reportId: string | undefined): number {
  const reportingConfigs = useSelector(
    (s: RootState) => s.globalConfigs?.reporting_configs ?? []
  )
  return useMemo(() => {
    if (!reportId) return 0
    const cfg = reportingConfigs.find((c: any) => c?.id === reportId)
    const n = cfg?.freeze_leading_columns
    return typeof n === 'number' && n > 0 ? n : 0
  }, [reportingConfigs, reportId])
}
